import { Components, Theme } from '@mui/material/styles';

export const alertConfigs: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),

      '.MuiAlert-icon': {
        marginRight: theme.spacing(0.75),
        padding: 0,

        '.MuiSvgIcon-root': {
          height: 20,
          width: 20,
        },
      },

      '.MuiAlert-message': {
        fontSize: theme.typography.captionBold.fontSize,
        fontWeight: theme.typography.captionBold.fontWeight,
        padding: 0,
        overflow: 'visible',
      },
    }),
    filled: ({ theme }) => ({
      '.MuiAlert-icon': {
        '.MuiSvgIcon-root': {
          fill: theme.palette.common.white,
        },
        '.MuiAlert-message': {
          color: theme.palette.common.white,
        },
      },
    }),
    standardError: ({ theme }) => ({
      backgroundColor: theme.palette.red[100],
      '.MuiSvgIcon-root': {
        fill: theme.palette.red[500],
      },
      '.MuiAlert-message': {
        color: theme.palette.red[600],
      },
    }),
    standardWarning: ({ theme }) => ({
      backgroundColor: theme.palette.orange[100],
      '.MuiSvgIcon-root': {
        fill: theme.palette.orange[500],
      },
      '.MuiAlert-message': {
        color: theme.palette.orange[600],
      },
    }),
    standardInfo: ({ theme }) => ({
      backgroundColor: theme.palette.primaries[100],
      '.MuiSvgIcon-root': {
        fill: theme.palette.primaries[400],
      },
      '.MuiAlert-message': {
        color: theme.palette.primaries[600],
      },
    }),
    standardSuccess: ({ theme }) => ({
      backgroundColor: theme.palette.green[100],
      '.MuiSvgIcon-root': {
        fill: theme.palette.green[500],
      },
      '.MuiAlert-message': {
        color: theme.palette.green[600],
      },
    }),
    outlinedInfo: ({ theme }) => ({
      backgroundColor: theme.palette.primaries[100],
      border: `1px solid ${theme.palette.primary.main}`,
      '.MuiSvgIcon-root': {
        fill: theme.palette.primaries[400],
      },
      '.MuiAlert-message': {
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
      },
    }),
  },
};
